<template>
  <div ref="wrapper" class="z-max fixed inset-0 hidden duration-200 opacity-0">
    <div
      @click="togglePhotoPreview()"
      class="absolute inset-0 z-0"
      :class="{'bg-black/70': theme === 'light', 'bg-concrete/80': theme === 'dark'}"
    />
    <div
      v-if="photos.length > 1"
      v-show="navigationEnabled"
      @click="prev()"
      class="md:left-8 left-1 md:w-14 w-9 md:h-14 h-9 z-max fixed bottom-0 items-center justify-center duration-200 bg-white rounded-lg cursor-pointer"
      style="box-shadow: 0px 5px 10px rgba(31, 31, 31, 0.12); top: 50%; display: flex"
    >
      <ph-caret-left :size="24" class="text-black" />
    </div>
    <t-loader-circle v-if="!loaded" class="fixed" style="top: calc(50% - 24px); left: calc(50% - 24px)" />
    <carousel
      class="fixed flex flex-col justify-center"
      ref="carousel"
      :style="
        viewport.width >= $screen.md
          ? {
              top: 'calc(env(safe-area-inset-top) + 88px)',
              right: 'calc(env(safe-area-inset-right) + 56px)',
              bottom: 'calc(env(safe-area-inset-bottom) + 16px)',
              left: 'calc(env(safe-area-inset-left) + 56px)'
            }
          : {
              top: 'calc(env(safe-area-inset-top) + 56px) !important',
              right: 'calc(env(safe-area-inset-right) + 24px) !important',
              bottom: 'calc(env(safe-area-inset-bottom) + 16px) !important',
              left: 'calc(env(safe-area-inset-left) + 24px) !important'
            }
      "
      :navigationEnabled="navigationEnabled"
      :perPage="1"
      :paginationActiveColor="'#FFFFFF'"
      :paginationColor="'rgba(255, 255, 255, .4)'"
      :paginationSize="7"
      :paginationPadding="5"
      :resetPages="false"
      v-else-if="loaded && zoomable === false"
    >
      <slide v-for="photo in photos" :key="photo.id" class="min-w-full min-h-full">
        <v-zoomer ref="zoomer" :limitTranslation="false" class="w-full h-full" style="border: solid 1px transparent">
          <div class="w-full h-full max-w-full max-h-full">
            <img :src="photo.url || photo.preview_url || photo" class="object-contain w-full h-full select-none" />
          </div>
        </v-zoomer>
      </slide>
    </carousel>
    <v-zoomer
      v-else-if="loaded && zoomable === true"
      class="fixed flex flex-col justify-center"
      :limitTranslation="false"
      :style="
        viewport.width >= $screen.md
          ? {
              top: '0px',
              right: '0px',
              bottom: '0px',
              left: '0px'
            }
          : {
              top: '0px !important',
              right: '0px !important',
              bottom: '0px !important',
              left: '0px !important'
            }
      "
      style="border: solid 1px transparent"
    >
      <div class="w-full h-full max-w-full max-h-full">
        <img :src="photos[0]" class="object-contain w-full h-full pointer-events-none select-none" />
      </div>
    </v-zoomer>
    <div
      @click="togglePhotoPreview()"
      class="z-max md:w-unset md:h-10 md:px-10 md:py-2 md:bg-white md:gap-2 md:font-semibold md:rounded-lg fixed flex items-center justify-center w-10 h-10 text-black duration-200 bg-white rounded-lg opacity-100 cursor-pointer"
      :style="viewport.width < $screen.md ? {left: 'calc(env(safe-area-inset-left) + 20px)'} : {left: 'calc(50% - 80px)'}"
      style="top: calc(env(safe-area-inset-top) + 12px)"
    >
      <ph-caret-left :size="24" v-if="viewport.width < $screen.md" class="text-black" />
      <ph-x :size="24" v-if="viewport.width >= $screen.md" class="text-black" />
      <t-text v-if="viewport.width >= $screen.md">{{ $t('components.photoPreview.close') }}</t-text>
    </div>
    <div
      v-if="viewport.width < $screen.md"
      @click="togglePhotoPreview()"
      class="z-max md:w-8 md:h-8 fixed flex items-center justify-center w-10 h-10 duration-200 bg-white rounded-lg opacity-100 cursor-pointer"
      style="top: calc(env(safe-area-inset-top) + 12px); right: calc(env(safe-area-inset-right) + 20px)"
    >
      <ph-x :size="24" class="text-black" />
    </div>
    <div
      v-if="photos.length > 1"
      v-show="navigationEnabled"
      @click="next()"
      class="md:right-8 right-1 md:w-14 w-9 md:h-14 h-9 z-max fixed bottom-0 items-center justify-center duration-200 bg-white rounded-lg cursor-pointer"
      style="box-shadow: 0px 5px 10px rgba(31, 31, 31, 0.12); top: 50%; display: flex"
    >
      <ph-caret-right :size="24" class="text-black" />
    </div>
  </div>
</template>

<script>
  import AXIOS from '@/integrations/axios'
  import {mapGetters} from 'vuex'
  import {mapMutations} from 'vuex'
  import {Carousel, Slide} from '@/integrations/carousel'
  import handleViewport from '@/utils/mixins/handleViewport'
  export default {
    name: 'photo-preview',
    data() {
      return {
        photosUnfiltered: [],
        opened: false,
        loaded: false,
        cursorPositionY: 0,
        startingPoint: 0,
        optionsConstHeight: 0,
        heightOnResize: 0,
        isDragging: false,
        zoomable: false,
        navigationEnabled: true
      }
    },
    components: {
      Carousel,
      Slide
    },
    mixins: [handleViewport],
    methods: {
      ...mapMutations('layout', ['togglePhotoPreview']),
      next() {
        const nextBtn = document.querySelector('.VueCarousel-navigation-next')
        nextBtn && nextBtn.click()
      },
      mousedown(e) {
        if (e.type && e.type == 'touchstart') {
          this.cursorPositionY = e.changedTouches[0].clientY
        }
        this.startingPoint = this.cursorPositionY
        this.isDragging = true
      },
      mouseup(e) {
        this.isDragging = false
        if (this.startingPoint - this.cursorPositionY < -55) {
          this.togglePhotoPreview()
        } else {
          e.target.style.transition = '.2s'
          setTimeout(() => {
            e.target.style.marginTop = '0px'
          }, 0)
          setTimeout(() => {
            e.target.style.transition = 'unset'
          }, 250)
        }
      },
      resize(e) {
        this.cursorPositionY = e.clientY ? e.clientY : e.changedTouches[0].clientY
        if (this.isDragging) {
          this.heightOnResize = this.cursorPositionY - this.startingPoint
          if (this.heightOnResize > 0) e.target.style.marginTop = this.heightOnResize + 'px'
        }
      },
      handleIndex() {
        if (this.PhotoPreview._params.position !== null && this.PhotoPreview._params.position !== 0) {
          for (let i = 0; i < this.PhotoPreview._params.position; i++)
            setTimeout(() => {
              this.next()
            }, 300)
        }
        this.$forceUpdate()
      },
      async zoomerReady() {
        return new Promise(resolve => {
          const interval = setInterval(() => {
            if (this.$refs.zoomer && this.$refs.zoomer.length) {
              clearInterval(interval)
              resolve()
            }
          }, 333)
        })
      },
      handleScaleChange(newVal) {
        if (newVal !== 1) {
          this.$refs.carousel.disabled = true
          this.navigationEnabled = false
        } else {
          this.$refs.carousel.disabled = false
          this.navigationEnabled = true
        }
      },
      prev() {
        document.querySelector('.VueCarousel-navigation-prev').click()
      }
    },
    watch: {
      'PhotoPreview._params.media'(newVal) {
        if (!this.PhotoPreview._hidden) {
          if (this.PhotoPreview._params.fetch_url) {
            this.photosUnfiltered = []
            const reqs = []
            newVal.forEach(el => {
              reqs.push(
                AXIOS.get(this.PhotoPreview._params.fetch_url + el.id)
                  .then(res => {
                    this.photosUnfiltered.push(res.data)
                  })
                  .catch(err => {
                    console.log(err)
                  })
              )
            })

            Promise.all(reqs).then(() => {
              this.key++
              this.loaded = true
              if (this.PhotoPreview._params.position)
                setTimeout(() => {
                  this.handleIndex()
                }, 0)
            })
          } else {
            this.photosUnfiltered = newVal

            setTimeout(() => {
              this.loaded = true
              if (this.PhotoPreview._params.position)
                setTimeout(() => {
                  this.handleIndex()
                }, 0)
              if (this.PhotoPreview._params.zoomable) this.zoomable = true
            }, 1500)
          }
        }
      },
      'PhotoPreview._hidden'(newVal) {
        if (!newVal) {
          // open
          this.$refs.wrapper.classList.replace('hidden', 'flex')
          setTimeout(async () => {
            this.$refs.wrapper.classList.replace('opacity-0', 'opacity-100')
            await this.zoomerReady()
            this.$refs.zoomer.forEach(zoomer => {
              this.$watch(() => zoomer.scale, this.handleScaleChange)
            })
          }, 0)
        } else {
          // close
          this.$refs.wrapper.classList.replace('opacity-100', 'opacity-0')
          setTimeout(() => {
            this.$refs.wrapper.classList.replace('flex', 'hidden')
            this.zoomable = false
            this.navigationEnabled = true
            this.loaded = false
          }, 200)
        }
      }
    },
    computed: {
      ...mapGetters('layout', ['PhotoPreview']),
      ...mapGetters(['theme']),
      photos() {
        let arr = JSON.parse(JSON.stringify(this.photosUnfiltered))
        return arr.sort((a, b) => {
          return a.position > b.position ? 1 : a.position < b.position ? -1 : 0
        })
      }
    }
  }
</script>
